<div class="track">
  <div class="fill" [style.width.%]="progress">
    @if (progress < 98) {
      <div class="pulse"></div>
    }
  </div>
</div>
